import { createContext, useContext, ReactNode } from "react";
import { useSiteContent, ContentLoadState } from "@/hooks/useSiteContent";

interface SiteContentContextValue {
  loadState: ContentLoadState;
  lastUpdated: string | null;
  syncFromSupabase: () => Promise<{ success: boolean; count: number; error?: string }>;
}

const SiteContentContext = createContext<SiteContentContextValue | null>(null);

export function SiteContentProvider({ children }: { children: ReactNode }) {
  const value = useSiteContent();
  return (
    <SiteContentContext.Provider value={value}>
      {children}
    </SiteContentContext.Provider>
  );
}

export function useSiteContentContext(): SiteContentContextValue {
  const ctx = useContext(SiteContentContext);
  if (!ctx) throw new Error("useSiteContentContext must be used inside SiteContentProvider");
  return ctx;
}
